jQuery(document).ready(function () {
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  function getLastWordFromURL() {
    var url = window.location.href;
    var parts = url.split("/");
    var lastPart = parts[parts.length - 1] || parts[parts.length - 2]; // Handle trailing slash
    return lastPart;
  }

  var page = __st.p;

  if (page == "product") {
    var prod_id = __st.rid;
    var prod_title = jQuery(".product-form .title-row .title").text();
    var productHandle = jQuery(".product-form .title-row .title").data("product-handle");
    let productType = jQuery(".product-form").data("product-type") || "";
    let productOccasion = jQuery(".product-form .title-row .title").data("occasion")
    var imageUrl = jQuery(".product-form .title-row .title").data("image-url");
    var price = jQuery(".price-container .current-price").text();
    var amount = price.replace("₹ ", "");

    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");

      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";

      var source = "Direct";
    }
    var prod_sku=jQuery("[name='id'] option:selected").attr("data-sku");

    clevertap.event.push("Viewed Product", {
      user_source: source,
      sku: prod_sku,
      product_name: prod_title,
      product_category: "",
      product_url: productHandle,
      product_image: imageUrl,
      product_price: amount,
      product_occasion: productOccasion,
      product_type: productType,
      utm_campaign: utm_campaign,
      utm_medium: utm_medium,
      utm_source: utm_source,
    });
  } else if (page == "collection") {
    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");
      var source_page = "social";
      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";
      var source_page = "";
      var source = "Direct";
    }
    var collection_title = jQuery(
      ".container  .overlay-text__inner .overlay-text__title"
    ).text();
    var collection_url = window.location.href;
  } else if (page == "home") {
    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");
      var source_page = "social";
      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";
      var source_page = "";
      var source = "Direct";
    }
    var collection_title = jQuery(
      ".container  .overlay-text__inner .overlay-text__title"
    ).text();
    var collection_url = window.location.href;
    if (__st.cid != undefined) {
      var user_id = __st.cid;
    } else {
      var user_id = "";
    }
    var d = new Date();
    clevertap.event.push("ViewedHomepage", {
      source: source,
      timestamp: d,
      user_id: user_id,
      utm_campaign: utm_source,
      utm_medium: utm_medium,
      utm_source: utm_source,
    });
  } else if (page == "page") {
    var lastWord = getLastWordFromURL();
    page = lastWord;
  } else {
    var lastWord = getLastWordFromURL();
    page = lastWord;
  }
  jQuery(document).on("click", ".mm-ajaxcart-open", function () {
    clevertap.event.push("Clicked Cart");
  });

  /******* Recently Viewd Product Clicked *********/
  document.addEventListener('click', function (e) {
    let recentItem = e.target.closest('.ct-recently-viewed li');
    if (!recentItem) return;

    let titleLink = recentItem.querySelector('a[data-title]');
    if (!titleLink) return;

    let title = titleLink.getAttribute('data-title');
    clevertap.event.push("Clicked Recently Viewed", {
      "Product name": title,
      "Page Name": page,
    });
  });
  /******* User Account icon  Clicked *********/
  jQuery(document).on('click', '.opposing-items button', function () {
    clevertap.event.push("Login Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on('click', '.ct_log_out', function () {
    clevertap.event.push("Logout Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".header-account-link", function () {
    clevertap.event.push("Account Icon Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box.order-box-0", function () {
    clevertap.event.push("Profile Viewed", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box-orders", function () {
    clevertap.event.push("Orders Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box-contact-us", function () {
    clevertap.event.push("Contact Us Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box-stores", function () {
    clevertap.event.push("Stores Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box-addresses", function () {
    clevertap.event.push("Address Clicked", {
      interaction_type: page,
    });
  });


  /******* User Wishlist icon  Clicked *********/
  jQuery(document).on("click", ".header_hhrt", function () {
    clevertap.event.push("Clicked Wishlist Icon", {
      "page name": page,
    });
  });

  /******* Home page Banner Clicks *********/
  jQuery(document).on("click", '.imagegrid-box', function () {
    let index = jQuery(this).attr('data-index');
    let title = jQuery(this).attr('data-title');
    let subtitle = jQuery(this).attr('data-subtitle');
    const toApp = {
      index: index,
      title: title,
      subtitle: subtitle
    };

    if (window.KushalsNativeCleverTap) {
      KushalsNativeCleverTap.pushEvent("Home Page Banner Click", JSON.stringify(toApp));
    } else {
      clevertap.event.push("Home Page Banner Click", {
        "index": index,
        "title": title,
        "subtitle": subtitle
      });
    }
  });

  jQuery(document).on("click", '.homepage-tab-section', function () {
    let index = jQuery(this).attr('data-index');
    let title = jQuery(this).attr('data_page_target_btn');
    let subtitle = jQuery(this).attr('data-subtitle');
    clevertap.event.push("Home Page Tab Click", {
      "index": index,
      "title": title,
      "subtitle": subtitle
    });
  });

  /******* Product Wishlist icon  Clicked *********/
  jQuery(document).on("click", ".zoomywishidheart .zoomycheck", function () {
    var $this = jQuery(this).closest(".zoomywishid");
    var title = $this.attr("data-title");
    var prod_price = $this.attr("data-price");
    var prod_id = $this.attr("data-product-id");
    var page_url = __st.pageurl;

    clevertap.event.push("Wishlisted", {
      wishlisted_product_type: "",
      wishlisted_product_name: title,
      wishlisted_product_price: prod_price,
      wishlisted_product_id: prod_id,
      page_url: page_url,
    });
  });
  /******* Click on Begin Checkout button *********/
jQuery(document).on("click", ".ct_snapmint_checkout, .ct_snapmint_order_btn", function (e) {

  let customerCity = "";
  try {
    let locData = localStorage.getItem("location_store");
    if (locData) {
      locData = JSON.parse(locData);
      customerCity = locData.city || "";
    }
  } catch (err) {
    console.error("City fetch error:", err);
  }

  var $firstItem = jQuery('.mm-ajaxcart-item').first();

  if (!$firstItem.length) {
    // no items, just fire basic event
    clevertap.event.push("Begin Checkout");
    return;
  }

  // First product details (unit price)
  var firstProductName     = $firstItem.attr('data-prod-title') || '';
  var firstProductImageUrl = $firstItem.find('.mm-ajaxcart-item-image img').attr('src') || '';
  var firstProductUrl      = $firstItem.find('.mm-ajaxcart-item-name a').attr('href') || '';
  var firstProductPrice    = $firstItem.attr('data_main_price') || ''; // unit price in INR
  var firstProductCategory = $firstItem.attr('data-prod-type') || '';

  //  Calculate total cart pricec
  let totalCartPrice = 0;

  jQuery('.mm-ajaxcart-item').each(function () {
    var $item = jQuery(this);

    let price = parseFloat($item.attr('data_main_price')) || 0;   // unit price
    let qty   = parseInt($item.find('.quantity-input').val(), 10) || 1; // quantity

    totalCartPrice += price * qty;
  });

  clevertap.event.push("Begin Checkout", {
    "First Product Name": firstProductName,
    "First Product Image": firstProductImageUrl,
    "First Product URL": firstProductUrl,
    "First Product Price": firstProductPrice,
    "First Product Category": firstProductCategory,
    "Total Cart Price": totalCartPrice,
    "Customer City": customerCity
  });

});

const GIFT_SETTINGS_CACHE_KEY = "gift_settings_cache_v1";

function getGiftSettingsFromCache() {
  try {
    const raw = localStorage.getItem(GIFT_SETTINGS_CACHE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return parsed;
  } catch (e) {
    return null;
  }
}

// Map: variantId -> { tier: "T1|T2|T3", name: "Mini/Medium/Large..." }
function buildGiftVariantMap(giftSettings) {
  const map = new Map();
  if (!giftSettings || typeof giftSettings !== "object") return map;

  // Current API shape: { cartGiftingDTOS: [{ variantId, priceRangeMin, ... }, ...] }
  const dtos = Array.isArray(giftSettings.cartGiftingDTOS) ? giftSettings.cartGiftingDTOS : [];
  if (dtos.length) {
    const tiersSorted = dtos
      .map((d) => ({
        variantId: Number(d.variantId),
        minRupees: Number(d.priceRangeMin),
      }))
      .filter((d) => Number.isFinite(d.variantId) && Number.isFinite(d.minRupees))
      .sort((a, b) => a.minRupees - b.minRupees);

    const tierLabels = ["T1", "T2", "T3"];
    const giftNames = ["Mini Jewelry Box", "Medium Jewelry Box", "Large Jewelry Box"];

    tiersSorted.forEach((t, idx) => {
      const tier = tierLabels[idx] || `T${idx + 1}`;
      const name = giftNames[idx] || "Jewelry Box";
      map.set(String(t.variantId), { tier, name });
    });

    return map;
  }

  // Legacy fallback shape: { T1: { variant_ids: [] }, T2: ... }
  ["T1", "T2", "T3"].forEach((tier) => {
    const tierObj = giftSettings[tier];
    if (!tierObj) return;

    const ids = tierObj.variant_ids || tierObj.variantIds || tierObj.variants || [];
    const displayName =
      tierObj.name ||
      tierObj.title ||
      tierObj.label ||
      (tier === "T1" ? "Mini Jewelry Box" : tier === "T2" ? "Medium Jewelry Box" : "Large Jewelry Box");

    (Array.isArray(ids) ? ids : []).forEach((id) => {
      map.set(String(id), { tier, name: displayName });
    });
  });

  return map;
}

function getCartItemVariantId($item) {
  // adjust if your cart DOM uses a different attribute
  return (
    $item.attr("data-variant_id") ||
    $item.attr("data-variant-id") ||
    $item.attr("data-variant") ||
    $item.find('[name="id"]').val() ||
    ""
  );
}

jQuery(document).on("click", ".ct_snapmint_checkout, .ct_snapmint_order_btn", function (e) {
  // --- your existing Begin Checkout code stays exactly the same above ---

  // NEW: Fire FreeBox_Offer_Applied with ONLY Gift Name + Tier
  const giftSettings = getGiftSettingsFromCache();
  const giftVariantMap = buildGiftVariantMap(giftSettings);

  if (giftVariantMap.size) {
    const found = [];

    jQuery(".mm-ajaxcart-item").each(function () {
      const $item = jQuery(this);
      const vid = String(getCartItemVariantId($item) || "").trim();
      if (!vid) return;

      const meta = giftVariantMap.get(vid);
      if (meta) found.push(meta); // {tier, name}
    });

    if (found.length) {
      const giftName = found[0].name || "";
      const giftTier = found[0].tier || "";
      const payload = {
        Gift_Name: giftName,
        Gift_Tier: giftTier,
      };
      clevertap.event.push("FreeBox_Offer_Applied", payload);
    }
  }
});


  /******* Click Remove button on cart drawer*********/
  jQuery(document).on("click", ".mm-ajaxcart-remove-item", function (e) {
    e.preventDefault();
    let product_data = {
      "product_id": jQuery(this).closest('li').data("prod-id"),
      "product_name": jQuery(this).closest('li').data("prod-title"),
      "product_price": jQuery(this).closest('li').attr("data_main_price"),
      "page_url": __st.pageurl,
      "sku": jQuery(this).closest('li').attr("data-sku"),
      "product_quantity": 1,
    };

    clevertap.event.push("RemoveFromCart", product_data);
    return true;
  });

  /******* Jewellery Finder CTA *********/
  jQuery(document).on("click", ".jf-cta", function () {
    clevertap.event.push("Jewellery Finder Used", {
      page_name: page,
    });
  });

  /******* Click on Banner *********/
  jQuery(document).on(
    "click",
    ".mm-ajaxcart-remove-item.slick-current.slick-active a",
    function () {
      // clevertap.event.push("BannerClicked", {
      //                   "BannerID":
      //                   "BannerPosition":
      //                   "DestinationPageURL":
      //                   "BannerName":
      //                 });
    }
  );

  /******* Click on humburger menu *********/
  jQuery(document).on("click", "#pageheader .mobile-nav-toggle", function () {
    clevertap.event.push("HamburgerMenuUsed");
  });

  /******* Click on Similar Product Click*********/

  jQuery(document).on("click", ".CT_product-block .product-link", function () {
    var prod_id = jQuery(this)
      .closest(".CT_product-block")
      .attr("data-product-id");
    clevertap.event.push("SimilarProductClicked", {
      ProductID: prod_id,
    });
  });

  /******* Click on Product Image *********/
  jQuery(document).on(
    "click",
    ".product-media  .CT-rimage__image",
    function () {
      var prod_title = jQuery(".product-form .title-row .title").text();
      clevertap.event.push("Product Image Clicked", {
        product_name: prod_title,
      });
    }
  );

  /******* Click on Cart Icon click  *********/
  jQuery(document).on("click", ".mm-ajaxcart-open", function () {
    clevertap.event.push("Clicked Cart");
  });

  /******* Click on Banner Click  *********/
  jQuery(document).on(
    "click",
    ".slick-track .ct_slide .image-overlay__image-link",
    function () {
      var destination = jQuery(this).attr("href");
      var banner_position = jQuery(this)
        .closest(".ct_slide")
        .attr("data-slick-index");
      var segments = destination.split("/");
      var banner_name = segments.pop() || segments.pop(); // Handles trailing slash

      let toApp = {
        BannerID: banner_position,
        BannerPosition: banner_position,
        DestinationPageURL: destination,
        BannerName: banner_name,
      }

      if (window.KushalsNativeCleverTap) {
        KushalsNativeCleverTap.pushEvent("BannerClicked",JSON.stringify(toApp));
      } else {
        clevertap.event.push("BannerClicked", {
          BannerID: banner_position,
          BannerPosition: banner_position,
          DestinationPageURL: destination,
          BannerName: banner_name,
        });
      }
    }
  );
  /******* Click on Banner Click for ALL Others   *********/
  jQuery(document).on("click", ".ct_banner_click_clevertap", function (e) {
    e.preventDefault(); // Prevent immediate redirect

    var destination = jQuery(this).attr("href");
    var banner_position = jQuery(this).attr("data-count");
    var segments = destination.split("/");
    var banner_name = segments.pop() || segments.pop(); // Handles trailing slash

    // Push event to CleverTap

    let toApp = {
      BannerID: banner_position,
      BannerPosition: banner_position,
      DestinationPageURL: destination,
      BannerName: banner_name,
    }

    if (window.KushalsNativeCleverTap) {
      KushalsNativeCleverTap.pushEvent("BannerClicked",JSON.stringify(toApp));
    } else {
      clevertap.event.push("BannerClicked", {
        BannerID: banner_position,
        BannerPosition: banner_position,
        DestinationPageURL: destination,
        BannerName: banner_name,
      });
    }
    // Redirect after a slight delay to ensure the event is sent
    setTimeout(function () {
      window.location.href = destination;
    }, 500); // Adjust the delay if needed
  });

  /******* Click on Location Click  *********/
  jQuery(document).on("click", ".ct_location", function () {
    var page_name = getLastWordFromURL();

    clevertap.event.push("Clicked Store Locator", {
      page_name: page_name,
    });
  });

  /******* Click on collection sort by  *********/
  jQuery(document).on("click", ".CT_link-dropdown__options a", function () {
    var ct_sort = jQuery(this).find(".ct_cl_sort").text();
    var page_url = window.location.href;
    clevertap.event.push("Sort Applied", {
      sort_type: ct_sort,
      landingpage_url: page_url,
    });
  });
  /******* Click on Product description  *********/
  jQuery(document).on("click", ".cc-accordion-item__title", function () {
    clevertap.event.push("checked_product_description", {
      checked_product_description: "click",
    });
  });
  /******* Click on humburger menu *********/
  jQuery(document).on("click", ".mobile-nav-toggle", function () {
    clevertap.event.push("Clicked Navigation");
  });

  /******* Click on Login Btn *********/
  jQuery(document).on("click", "#customer .action_bottom button", function (e) {
    var email = jQuery("#customer_email").val();
    var password = jQuery("#customer_password").val();
    if (email != "" && password != "") {
      clevertap.event.push("Login", {
        Method_Used: "shopify",
        Login_Status: "success",
      });
    } else {
      if (email != "" && password != "") {
        clevertap.event.push("Login", {
          Method_Used: "shopify",
          Login_Status: "failed",
        });
      }
    }
  });

  $("#one-click-social-login-buttons-1").on("load", function () {
    var iframeContent = $(this).contents(); // Access the iframe content

    iframeContent.find(".btn-google-plus").on("click", function (event) {
      event.preventDefault(); // Prevent the default googleLogin() from being called
      alert("Custom Google Login triggered");

      // Your custom login logic goes here
      clevertap.event.push("Login", {
        Method_Used: "Google",
        Login_Status: "success",
      });

      // Optionally, open Google login window or redirect
      // window.open('YOUR_GOOGLE_LOGIN_URL', '_blank'); // replace with actual login URL
    });

    iframeContent.find(".btn-facebook").on("click", function (event) {
      event.preventDefault(); // Prevent the default googleLogin() from being called
      alert("Custom Google Login triggered");

      // Your custom login logic goes here
      clevertap.event.push("Login", {
        Method_Used: "facebook",
        Login_Status: "success",
      });

      // Optionally, open Google login window or redirect
      // window.open('YOUR_GOOGLE_LOGIN_URL', '_blank'); // replace with actual login URL
    });
  });

  /******* Click on Sign up Btn *********/
  jQuery(document).on("click", "#customer .action_bottom button", function (e) {
    var email = jQuery("#email").val();
    var password = jQuery("#password").val();
    if (email != "" && password != "") {
      clevertap.event.push("Sign Up", {
        Method_Used: "shopify",
        "Signup _Status": "success",
      });
    } else {
      if (email != "" && password != "") {
        clevertap.event.push("Sign Up", {
          Method_Used: "shopify",
          "Signup _Status": "failed",
        });
      }
    }
  });

  /******* Search input click *********/
  function pushCleverTapEvent(eventName, payload) {
    try {
      if (window.clevertap?.event?.push) clevertap.event.push(eventName, payload);
    } catch (err) {
      console.error('CleverTap push failed', err);
    }
  }

  const searchBar = document.querySelector('.ct_main-search__input');
  if (searchBar) {
    searchBar.addEventListener('click', () => {
      const pageName = typeof page !== 'undefined' ? page : window.location.pathname;
      pushCleverTapEvent('Clicked Search Bar', { page_name: pageName });
    });
  }

  // --- mutation observer: watch once ---
  const observer = new MutationObserver(() => {
    attachSuggestionListeners();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function attachSuggestionListeners() {
    // suggestion items (collections etc.)
    document
      .querySelectorAll(
        '.wizzy-autocomplete-suggestions .autocomplete-suggestions-list .autocomplete-item a'
      )
      .forEach((item) => {
        if (item.dataset.ctBound === '1') return;
        item.dataset.ctBound = '1';

        item.addEventListener('click', (e) => {
          const searchTerm = item.textContent.trim();
          pushCleverTapEvent('Search AutoSuggestion_clicked', {
            AutoSuggestion_value: searchTerm,
            type: 'collection',
          });
        });
      });

    // product items
    document
    .querySelectorAll('.autocomplete-top-products .topproduct-item a')
    .forEach((link) => {
      if (link.dataset.ctBound === '1') return;
      link.dataset.ctBound = '1';

      link.addEventListener(
        'click',
        (function () {
          let fired = false;
          return function (e) {
            if (fired) return;
            fired = true;

            const searchTerm =
              link.closest('li')?.getAttribute('title') ||
              link.getAttribute('title') ||
              link.textContent.trim();

            pushCleverTapEvent('Search AutoSuggestion_clicked', {
              AutoSuggestion_value: searchTerm,
              type: 'product',
            });

            e.preventDefault();
            setTimeout(() => {
              window.location.href = link.href;
            }, 400);
          };
        })()
      );
    });
  }

  // ---------------------
  // NEW SEARCH INPUT (#search)
  // ---------------------
  const newSearchInput = document.querySelector('#search');

  if (newSearchInput) {
    newSearchInput.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        const searchQuery = newSearchInput.value.trim();

        if (searchQuery) {
          pushCleverTapEvent('Searched', {
            search_query: searchQuery,
          });
        }
      }
    });
  }


  // run once immediately
  attachSuggestionListeners();

  /******* hamburger menu click *********/
  jQuery(document).on("click", ".ct_navigation__item", function () {
    var item = jQuery(this).find(".navigation__link:first").text();
    var main_menu_click = {
      "Item Name": item,
    };
    clevertap.event.push("HamburgerMenu Item Clicked", main_menu_click);
  });

  /******* hamburger menu click *********/
  jQuery(document).on(
    "click",
    ".navigation__tier-3 .navigation__item",
    function () {
      var item = jQuery(this).find(".navigation__link:first").text();
      var main_menu_click = {
        "Item Name": item,
      };
      clevertap.event.push("Hamburger Submenu Clicked", main_menu_click);
    }
  );
  /******* All circle click event *********/
  jQuery(document).on("click", ".all_circle_click_clickpost", function (e) {
    e.preventDefault();
    var link = jQuery(this).attr("href");
    var collection_title = jQuery(
      ".container  .overlay-text__inner:first .overlay-text__title"
    ).text();
    var coll_name = jQuery(this).attr("data-name");
    var page_url = window.location.href;
    var circle_coll_click = {
      "Category Name": collection_title,
      "Page URL": page_url,
      "Landing Page URL": link,
    };
    clevertap.event.push("Circle Menu Clicked", circle_coll_click);
    setTimeout(function () {
      window.location.href = link;
    }, 500);
  });

  jQuery(document).on("click", ".call-banner a", function (e) {
    e.preventDefault();
    var link = jQuery(this).attr("href");
    var lastWord = getLastWordFromURL();
    var bridal = {
      Phone: link,
      Page: lastWord,
    };
    clevertap.event.push("Call_Stylist", bridal);
    setTimeout(function () {
      window.location.href = link;
    }, 500);
  });
});

// PLP Product Click Event
document.addEventListener('click', function (e) {
  if (!(window.page === 'collection' || document.body.classList.contains('template-collection'))) return;

  const product = e.target.closest('.CT_product-block.product-block');
  if (!product) return;

  let productId = product.getAttribute('data-product-id');
  let prodPrice = product.getAttribute('data-prodprice');
  let prodUrl = product.getAttribute('data-prodURL');
  let imageUrl = product.getAttribute('data-imageUrl');
  let prodCategory = product.getAttribute('data-prodcategory');
  let prodSubCategory = product.getAttribute('data-prodsubcategory');
  let prodOccation = product.getAttribute('data-prodoccation');
  let currentPage = parseInt(product.getAttribute('data-currentpage'), 10);
  let currentPosition = parseInt(product.getAttribute('data-currentposition'), 10);
  let isPinned = product.getAttribute('data-ispinned') === 'true';
  let collectionTitle = product.getAttribute('data-collection');
  let productTitle = product.getAttribute('data-product');

  // Adjust position if not on first page
  if (currentPage !== 1) {
    let firstPageProduct = document.querySelectorAll('.first-page-prod');

    if (firstPageProduct.length > 0) {
      let pinnedCount = parseInt(firstPageProduct[0].getAttribute('data-pinnedCount') || '0', 10);
      let nonPinnedCount = parseInt(firstPageProduct[0].getAttribute('data-nonpinnedCount') || '0', 10);

      currentPosition += pinnedCount + nonPinnedCount + ((currentPage - 2) * 16);
    }
  }

  clevertap.event.push("PLP Product Clicked", {
    product_id: productId,
    current_position: currentPosition,
    is_pinned: isPinned,
    collection_title: collectionTitle,
    product_title: productTitle,
    prodPrice: prodPrice,
    prodUrl: prodUrl,
    imageUrl: imageUrl,
    prodCategory: prodCategory,
    prodSubCategory: prodSubCategory,
    prodOccation: prodOccation
  });
});


//UTM Parameters Event
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source') || '';
  const utmMedium = urlParams.get('utm_medium') || '';
  const utmCampaign = urlParams.get('utm_campaign') || '';

  const cleanUrl = window.location.origin + window.location.pathname;

  let toApp = {
    page_url: cleanUrl,
    page_title: document.title,
    page_type: __st.p,
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign
  }

  if (window.KushalsNativeCleverTap) {
    KushalsNativeCleverTap.pushEvent("Page Browsed",JSON.stringify(toApp));
  } else {
  clevertap.event.push("Page Browsed", {
    page_url: cleanUrl,
    page_title: document.title,
    page_type: __st.p,
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign
  });
  }
});

if(window.page === 'collection') {
  const page_name = document.querySelector('.ct_header_title-main').textContent;
  clevertap.event.push('Category_Browsed', {
    last_page: document.referrer,
    page_url: window.location.href,
    page_name: page_name,
  })
}


const appDownloadBanner = document.querySelectorAll('.app-download-banner-inner');

document.addEventListener('click', (event) => {
  const banner = event.target.closest('.app-download-banner-inner');
  if (!banner) return;
  clevertap.event.push('App Download Banner Clicked', {
    page_url: window.location.href,
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream ? 'Yes' : 'No'
  });
});


kReelsCTProductATC = function(params){
  try{
    const p = params || {};
    clevertap.event.push("Product CTA Click", {
      video_id: String(p.video_id || ""),
      product_id: String(p.product_id || ""),
      product_title: String(p.product_title || ""),
      action_type: "AddToCart",
      placement: "LP"
    });
  }catch(e){}
};
